export const getField = (input:string)=>{
    const regex = /{{(.*?)}}/;
    const match = input.match(regex);
    if(!match){
        return ""
    }
    const innerString = match?.[1]
    return innerString.split(":")[0]
}